import useChatRequestsFunctions from './ChatRequests/useChatRequestsFunctions';
import ChatInvites from './ChatRequests/ChatInvites';
import SendRequests from './ChatRequests/SendRequests';
import SentRequests from './ChatRequests/SentRequests';
import ErrorToast from '../../components/Toast/ErrorToast';
import SuccessToast from '../../components/Toast/SuccessToast';
import { S } from '../regureStyles';
import { useTranslation } from 'react-i18next';

const ChatRequestsModal = ({ socket, onClose }) => {
  const { t } = useTranslation();
  const {
    chatUserLoading,
    chatUsers,
    chatUserSearch,
    setChatUserSearch,
    pendingCircularLoader,
    notAvailableCircularLoader,
    notAcceptedCircularLoader,
    showErrorToast,
    setShowErrorToast,
    showSuccessToast,
    setShowSuccessToast,
    toastMessage,
    pendingChatUserLoading,
    pendingChatUsers,
    pendingChatSearch,
    setPendingChatSearch,
    prevSentRequestLoading,
    prevSentRequests,
    prevSentSearch,
    setPrevSentSearch,
    cardListRef1,
    cardListRef2,
    cardListRef3,
    handleSendReqest,
    handleAcceptRequest,
    handleAcceptGroupRequest,
    handleCancelGroupRequest,
    handleRemoveRequest,
    handleCancelRequest,
    pendingSearch,
    notAvailableusersSearch,
    notAcceptedUsersSearch,
    userLogin,
  } = useChatRequestsFunctions(socket);

  const style = { height: '60vh', overflow: 'auto' };

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={e => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, boxShadow: '0 24px 60px rgba(0,0,0,0.18)' }}>
        <div style={{ fontSize: 17, fontWeight: 700, color: S.textPrimary, marginBottom: 4 }}>{t('screens.chat.chatRequestsTitle')}</div>

        <div style={{ width: '60vw' }}>
          <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(3,1fr)' }}>
            {/* ── Chat Invites ── */}
            <div>
              <ChatInvites
                pendingChatSearch={pendingChatSearch}
                setPendingChatSearch={setPendingChatSearch}
                pendingSearch={pendingSearch}
                cardListRef1={cardListRef1}
                pendingChatUserLoading={pendingChatUserLoading}
                pendingChatUsers={pendingChatUsers}
                handleAcceptGroupRequest={handleAcceptGroupRequest}
                handleAcceptRequest={handleAcceptRequest}
                handleCancelGroupRequest={handleCancelGroupRequest}
                handleCancelRequest={handleCancelRequest}
                pendingCircularLoader={pendingCircularLoader}
                style={style}
                searchBoxStyles={{ padding: '14px 18px 6px' }}
              />
            </div>

            {/* ── Send Requests + Sent Requests (admin/fileAdmin only) ── */}
            {(!userLogin?.userInfo?.data?.user?.modules?.adminOnlyChat ||
              userLogin?.userInfo?.data?.user?.role === 'clientAdmin' ||
              userLogin?.userInfo?.data?.user?.role === 'fileAdmin') && (
              <>
                {/* Send Requests */}
                <div>
                  <SendRequests
                    topBorder={false}
                    chatUserSearch={chatUserSearch}
                    setChatUserSearch={setChatUserSearch}
                    notAvailableusersSearch={notAvailableusersSearch}
                    chatUserLoading={chatUserLoading}
                    cardListRef2={cardListRef2}
                    chatUsers={chatUsers}
                    handleSendReqest={handleSendReqest}
                    notAvailableCircularLoader={notAvailableCircularLoader}
                    style={style}
                  />
                </div>

                {/* Sent Requests */}
                <div>
                  <SentRequests
                    topBorder={false}
                    cardListRef3={cardListRef3}
                    prevSentSearch={prevSentSearch}
                    setPrevSentSearch={setPrevSentSearch}
                    notAcceptedUsersSearch={notAcceptedUsersSearch}
                    prevSentRequestLoading={prevSentRequestLoading}
                    prevSentRequests={prevSentRequests}
                    handleRemoveRequest={handleRemoveRequest}
                    notAcceptedCircularLoader={notAcceptedCircularLoader}
                    style={style}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 22px',
              background: '#fff',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              color: S.textSecondary,
            }}
          >
            {t('screens.chat.cancel')}
          </button>
        </div>
      </div>

      <ErrorToast message={toastMessage} showToast={showErrorToast} onClose={() => setShowErrorToast(false)} duration={3500} />
      <SuccessToast message={toastMessage} showToast={showSuccessToast} onClose={() => setShowSuccessToast(false)} duration={3500} />
    </div>
  );
};

export default ChatRequestsModal;
